var map = {
	"./ar-condicionado.svg": 1051,
	"./carro.svg": 1052,
	"./chef.svg": 1053,
	"./chuveiro.svg": 1054,
	"./dj.svg": 1055,
	"./eletrica.svg": 1056,
	"./fotografo.svg": 1057,
	"./frete.svg": 1058,
	"./garcon.svg": 1059,
	"./gesso.svg": 1060,
	"./hidraulica.svg": 1061,
	"./informatica.svg": 1062,
	"./jardim.svg": 1063,
	"./limpeza.svg": 1064,
	"./marido.svg": 1065,
	"./moveis.svg": 1066,
	"./pedreiro.svg": 1067,
	"./pintura.svg": 1068,
	"./piscina.svg": 1069,
	"./pisos.svg": 1070,
	"./vaso.svg": 1071,
	"./ventilador.svg": 1072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1050;